import type { DiagramSpec } from "../types"

/** Swimlane layout — each pipeline in its own bounded column */
export const swimlaneDiagram: DiagramSpec = {
  id: "swimlane",
  name: "Swimlane: Pipeline Comparison",
  description: "Two pipelines in bordered swim lanes",
  layers: [
    { id: "group", name: "Pipeline", color: "#64748b" },
    { id: "step", name: "Step", color: "#6366f1" },
  ],
  nodes: [
    // ── Group containers ──
    {
      id: "g-talking-head",
      label: "Talking Head Pipeline",
      layer: "group",
      isGroup: true,
      width: 260,
      height: 520,
      rank: 0,
    },
    {
      id: "g-animation",
      label: "Animation Pipeline",
      layer: "group",
      isGroup: true,
      width: 260,
      height: 420,
      rank: 0,
    },

    // ── Pipeline 1 children ──
    {
      id: "th-script",
      label: "Claude Sonnet",
      layer: "step",
      rank: 0,
      parentNode: "g-talking-head",
      description: "Script generation",
    },
    {
      id: "th-voice",
      label: "ElevenLabs",
      layer: "step",
      rank: 1,
      parentNode: "g-talking-head",
      description: "Voice synthesis",
    },
    {
      id: "th-video",
      label: "Seedance",
      layer: "step",
      rank: 2,
      parentNode: "g-talking-head",
      description: "Video from audio + image",
    },
    {
      id: "th-edit",
      label: "NanoBanana",
      layer: "step",
      rank: 3,
      parentNode: "g-talking-head",
      description: "Auto-edit & captions",
    },

    // ── Pipeline 2 children ──
    {
      id: "an-script",
      label: "Claude Sonnet",
      layer: "step",
      rank: 0,
      parentNode: "g-animation",
      description: "Script + scene prompts",
    },
    {
      id: "an-video",
      label: "Veo 3",
      layer: "step",
      rank: 1,
      parentNode: "g-animation",
      description: "Text-to-video generation",
    },
    {
      id: "an-edit",
      label: "NanoBanana",
      layer: "step",
      rank: 2,
      parentNode: "g-animation",
      description: "Auto-edit & captions",
    },
  ],
  edges: [
    { id: "e-th1", source: "th-script", target: "th-voice" },
    { id: "e-th2", source: "th-voice", target: "th-video" },
    { id: "e-th3", source: "th-video", target: "th-edit" },
    { id: "e-an1", source: "an-script", target: "an-video" },
    { id: "e-an2", source: "an-video", target: "an-edit" },
  ],
  views: [{ id: "main", name: "Swimlane", layout: "TB" }],
  defaultView: "main",
  preferences: {
    nodeWidth: 220,
    rankSpacing: 100,
    nodeGap: 24,
    showLayerBands: false,
    edgeStyle: "smoothstep",
  },
}
